import React, { useEffect, useState } from 'react';
import LoginForm from './form';
import styles from './style/index.module.less';
import {
  PageTypeLogin,
  PageTypeRegister,
  PageTypeRegisterByCaptcha,
  PageTypeResetPassword,
} from './constants';
import RegisterForm from './registForm';
import ForgetForm from './forgetForm';
import { Image, Radio, Tabs } from '@arco-design/web-react';
import request from '@/request/request';
import CaptchaLoginForm from './captchaLoginForm';
import CaptchaRegister from './captchaRegister';
function Login(props: { onSuccess?: () => void }) {
  const [pageType, setPageType] = useState(PageTypeLogin);
  const [subPageType, setSubPageType] = useState('1'); // 1-账密登录 2-验证码登录
  const params = new URLSearchParams(window.location.search);
  const [registAuthToken, setRegistAuthToken] = useState('');
  const [registMobile, setRegistMobile] = useState('');

  useEffect(() => {
    // document.body.setAttribute('arco-theme', 'light');
    fetchPromotionInfo();
  }, []);

  useEffect(() => {
    const pgType = +params.get('pageType');
    setPageType(pgType || PageTypeLogin);
  }, [window.location.search]);

  const [promotionInfo, setPromotionInfo] = useState(null);
  // 检查是否有channelId，如果有要加载一下
  const fetchPromotionInfo = async () => {
    const channelId = window.localStorage.getItem('channelId');
    // if (channelId) {
    try {
      const response = await request('/apiService/mechanism/promotionInfo', {
        data: {
          channelId: channelId,
        },
        method: 'GET',
      });
      if (response.data) {
        setPromotionInfo(response.data);

        document.title = response.data.assets.seoTitle || '软件造价喵';
      }
    } catch (e) {
      console.warn('e', e);
    } finally {
    }
    // }
  };

  const getForm = () => {
    switch (pageType) {
      case PageTypeLogin:
        return (
          <div style={{ width: 400 }}>
            <Tabs
              defaultActiveTab={subPageType}
              className={styles['login-tabs']}
            >
              <Tabs.TabPane
                key={'1'}
                title={
                  <span style={{ fontSize: 16, fontWeight: 'bold' }}>
                    手机号登录
                  </span>
                }
              >
                <CaptchaLoginForm
                  onSuccess={props.onSuccess}
                  userAgreemtnProtocol={
                    promotionInfo?.assets?.userAgreementProtocol
                  }
                  privacyPolicyProtocol={
                    promotionInfo?.assets?.privacyPolicyProtocol
                  }
                  onRegist={(authToken, mobile) => {
                    setRegistAuthToken(authToken);
                    setRegistMobile(mobile);
                    setPageType(PageTypeRegisterByCaptcha);
                  }}
                  onTypeChange={(pType) => {
                    setPageType(pType);
                  }}
                />
              </Tabs.TabPane>
              <Tabs.TabPane
                key={'2'}
                title={
                  <span style={{ fontSize: 16, fontWeight: 'bold' }}>
                    账号密码登录
                  </span>
                }
              >
                <LoginForm
                  onSuccess={props.onSuccess}
                  userAgreemtnProtocol={
                    promotionInfo?.assets?.userAgreementProtocol
                  }
                  privacyPolicyProtocol={
                    promotionInfo?.assets?.privacyPolicyProtocol
                  }
                  onTypeChange={(pType) => {
                    setPageType(pType);
                  }}
                />
              </Tabs.TabPane>
            </Tabs>
          </div>
        );
      case PageTypeRegister:
        return (
          <RegisterForm
            onSuccess={props.onSuccess}
            channelName={promotionInfo?.name}
            onTypeChange={(pType) => {
              setSubPageType('2');
              setPageType(pType);
            }}
          />
        );
      case PageTypeResetPassword:
        return (
          <ForgetForm
            onTypeChange={(pType) => {
              setSubPageType('2');
              setPageType(pType);
            }}
          />
        );
      case PageTypeRegisterByCaptcha:
        return (
          <CaptchaRegister
            onSuccess={props.onSuccess}
            channelName={promotionInfo?.name}
            authToken={registAuthToken}
            mobile={registMobile}
            onTypeChange={(pType) => {
              setSubPageType('1');
              setPageType(pType);
            }}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        {getForm()}
      </div>
    </div>
  );
}
Login.displayName = 'LoginPage';

export default Login;
